// extracted by mini-css-extract-plugin
export var allArticlesContainers = "articles-module--allArticlesContainers--b8c48";
export var arrow = "articles-module--arrow--14a68";
export var articlesContainer = "articles-module--articlesContainer--2bb3e";
export var circularContent = "articles-module--circularContent--a2406";
export var content = "articles-module--content--aa19e";
export var data = "articles-module--data--b0423";
export var date = "articles-module--date--eb504";
export var description = "articles-module--description--ba698";
export var highlightedArticle = "articles-module--highlightedArticle--9147b";
export var highlightedArticleContainer = "articles-module--highlightedArticleContainer--c52b8";
export var image = "articles-module--image--b0ad0";
export var imageContainer = "articles-module--imageContainer--dd903";
export var info = "articles-module--info--74a46";
export var location = "articles-module--location--02178";
export var mainInfo = "articles-module--mainInfo--7b9b8";
export var page = "articles-module--page--d3bc6";
export var pageButton = "articles-module--pageButton--f5744";
export var pagesContainer = "articles-module--pagesContainer--d8d4d";
export var paginationContainer = "articles-module--paginationContainer--b83c5";
export var title = "articles-module--title--78365";
export var type = "articles-module--type--e6aba";